import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Clock, RotateCcw, Home } from 'lucide-react';
import { api } from '../lib/api';
import { clearDraft } from '../lib/sessionStorage';
import { Button, Toast } from './ui';

interface StaleSessionProps {
  sessionId: number;
  ideaId: number;
}

export function StaleSession({ sessionId, ideaId }: StaleSessionProps) {
  const navigate = useNavigate();

  const recreateMutation = useMutation({
    mutationFn: async () => {
      await api.deleteSession(sessionId);
      clearDraft(sessionId);
      return api.createSession({ idea_id: ideaId });
    },
    onSuccess: (res) => {
      navigate(`/sessions/${res.session.id}`, { replace: true });
    },
  });

  return (
    <div className="min-h-screen p-6 max-w-lg mx-auto flex flex-col items-center justify-center text-center safe-top safe-bottom">
      <div className="w-16 h-16 rounded-2xl bg-warning-subtle text-warning flex items-center justify-center mb-4">
        <Clock size={28} />
      </div>
      <h1 className="text-xl font-semibold mb-2">Опросник устарел</h1>
      <p className="text-sm text-tg-hint mb-6 max-w-xs">
        Вопросы для этой идеи изменились. Сохранённые ответы больше не подходят.
      </p>

      {recreateMutation.error && (
        <Toast tone="destructive" className="mb-3 w-full max-w-xs">
          {recreateMutation.error.message}
        </Toast>
      )}

      <Button
        onClick={() => recreateMutation.mutate()}
        disabled={recreateMutation.isPending}
        loading={recreateMutation.isPending}
        variant="primary"
        size="lg"
        leftIcon={!recreateMutation.isPending ? <RotateCcw size={18} /> : undefined}
        className="w-full max-w-xs mb-2"
      >
        {recreateMutation.isPending ? 'Создаём' : 'Удалить и начать заново'}
      </Button>

      <Button
        onClick={() => navigate('/')}
        variant="secondary"
        size="lg"
        leftIcon={<Home size={18} />}
        className="w-full max-w-xs"
        hapticKind="light"
      >
        На главную
      </Button>
    </div>
  );
}
